import { Clear } from '@mui/icons-material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogTitle,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { action, computed, extendObservable, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ErrorUtil from '@/util/ErrorUtil';
import SecretariaService from '../service/SecretariaService';
import AutoComplete from './AutoComplete';
import ReactComponent from './ReactComponent';
import TelaUsuarioSemAutorizacaoAcesso from './TelaUsuarioSemAutorizacaoAcesso';
import ModalConfirmacao, { TIPO_CONFIRMACAO } from './sessao/ModalConfirmacao';
dayjs.extend(customParseFormat);

/** @type {number} */
const ID_TIPO_GERAL = 3;

/** @type {number} */
const ID_TIPO_FEATURE_FLAG = 8;

/** @type {import('react').CSSProperties} */
const stylePesquisa = {
    width: '100%',
    textAlign: 'right'
};

class ParametrosSistema extends ReactComponent {
    secretariaService = new SecretariaService();

    tipo = '';
    tipoParametroSelecionado = '';
    parametrosSelecaoCombo;
    parametroSelecionado;
    parametroParaAlteracao;
    abrirDialogEditarParametro = false;
    abrirDialogCriarParametro = false;
    abrirDialogExcluirParametro = false;
    idTipoParametro;
    dataInicioCriacaoParametro = null;
    dataFimCriacaoParametro = null;
    horaInicioCriacaoParametro = null;
    horaFimCriacaoParametro = null;
    tipoParametroCriacao = '';
    valorParametroCriacao = '';
    chaveParametroCriacao = '';
    valorFeatureFlag = true;
    idParametroExclusao;
    pesquisa = '';
    ordenacaoDecrescente = true;

    tiposParametros = [];

    constructor(props) {
        super(props);

        makeObservable(this, {
            tipo: observable,
            tipoParametroSelecionado: observable,
            parametrosSelecaoCombo: observable,
            parametroSelecionado: observable,
            parametroParaAlteracao: observable,
            abrirDialogEditarParametro: observable,
            abrirDialogCriarParametro: observable,
            abrirDialogExcluirParametro: observable,
            idTipoParametro: observable,
            dataInicioCriacaoParametro: observable,
            dataFimCriacaoParametro: observable,
            horaInicioCriacaoParametro: observable,
            horaFimCriacaoParametro: observable,
            tipoParametroCriacao: observable,
            valorParametroCriacao: observable,
            chaveParametroCriacao: observable,
            valorFeatureFlag: observable,
            idParametroExclusao: observable,
            pesquisa: observable,
            ordenacaoDecrescente: observable,
            carregaParametros: computed,
            listaFiltrada: computed,
            renderConteudoTipo: action,
            callbackAutoCompleteTiposParametros: action,
            callbackAutoCompleteTipoParametroCriado: action,
            opcoesTiposParametros: computed,
            editarParametro: action,
            criarParametro: action,
            reset: action,
            handleCloseDialog: action,
            onChangeDateInicio: action,
            onChangeHoraInicio: action,
            onChangeDateFim: action,
            onChangeHoraFim: action,
            onChangeDateInicioCriacao: action,
            onChangeHoraInicioCriacao: action,
            onChangeDateFimCriacao: action,
            onChangeHoraFimCriacao: action,
            handleChangeValorParametro: action,
            inputChaveParametroCriacao: action,
            inputValorParametroCriacao: action,
            salvar: action,
            cadastrarNovoParametro: action,
            excluirParametro: action,
            handleConfirmaExclusao: action,
            handleChangeSwitch: action,
            handleChangeValorFeatureFlag: action,
            pesquisar: action,
            limparPesquisa: action,
            sort: action
        });
    }

    async componentDidMount() {
        try {
            await this.parametroStore.inicializar();
            this.tiposParametros = this.parametroStore.getTiposParametros();
        } catch (error) {
            console.error(
                `Falha na inicialização do componente ParametrosSistema: ${ErrorUtil.getMensagemErro(error)}`
            );
            throw new Error('Falha na inicialização do componente ParametrosSistema', { cause: error });
        }
    }

    verificarAutorizacaoAcesso() {
        return this.usuarioStore.isUsuarioAdmin();
    }

    get carregaParametros() {
        return this.parametroStore.parametros.filter((parametro) => parametro.tipo.id === this.idTipoParametro);
    }

    get listaFiltrada() {
        if (this.ordenacaoDecrescente) {
            return this.parametrosSelecaoCombo
                .filter((parametro) => parametro.chave.toLowerCase().includes(this.pesquisa.toLowerCase()))
                .sort((a, b) => {
                    if (a.id > b.id) {
                        return 1;
                    }
                    if (a.id < b.id) {
                        return -1;
                    }
                    // a must be equal to b
                    return 0;
                });
        } else {
            return this.parametrosSelecaoCombo
                .filter((parametro) => parametro.chave.toLowerCase().includes(this.pesquisa.toLowerCase()))
                .sort((a, b) => {
                    if (a.id < b.id) {
                        return 1;
                    }
                    if (a.id > b.id) {
                        return -1;
                    }
                    // a must be equal to b
                    return 0;
                });
        }
    }

    async renderConteudoTipo(cadastrar = false) {
        let tipoParametro = cadastrar ? this.tipoParametroCriacao : this.tipoParametroSelecionado;
        let id = this.buscarIdTipoParametro(tipoParametro);

        if (cadastrar) {
            this.idTipoParametroCadastro = id;
        } else {
            this.idTipoParametro = id;
            let parametrosCarregados = this.carregaParametros;
            this.parametrosSelecaoCombo = parametrosCarregados;
        }
    }

    callbackAutoCompleteTiposParametros = (option) => {
        let valor = option && option.valor;
        this.tipoParametroSelecionado = valor;
        this.renderConteudoTipo();
        this.limparPesquisa();
    };

    callbackAutoCompleteTipoParametroCriado = (option) => {
        let valor = option && option.valor;
        this.tipoParametroCriacao = valor;
        this.renderConteudoTipo(true);
    };

    tipoParametroToOpcao(parametro) {
        return {
            texto: parametro.descricao,
            valor: parametro.descricao,
            parametrosBusca: [parametro.descricao]
        };
    }

    get opcoesTiposParametros() {
        return this.parametroStore.getTiposParametros().map((parametro) => this.tipoParametroToOpcao(parametro));
    }

    buscarIdTipoParametro(descricao) {
        let param = this.tiposParametros.find((parametro) => parametro.descricao === descricao);
        return param && param.id;
    }

    buscarDescricaoTipoParametro(id) {
        let param = this.tiposParametros.find((parametro) => parametro.id === id);
        return param && param.descricao;
    }

    editarParametro(parametro) {
        this.parametroParaAlteracao = { ...parametro };
        if (!this.parametroParaAlteracao.dataInicioVigencia) {
            extendObservable(this.parametroParaAlteracao, { dataInicioVigencia: null });
        } else {
            this.parametroParaAlteracao.dataInicioVigencia = dayjs(
                this.parametroParaAlteracao.dataInicioVigencia,
                'DD-MM-YYYY-HH-mm-ss'
            );
        }
        if (!this.parametroParaAlteracao.dataFimVigencia) {
            extendObservable(this.parametroParaAlteracao, { dataFimVigencia: null });
        } else {
            this.parametroParaAlteracao.dataFimVigencia = dayjs(
                this.parametroParaAlteracao.dataFimVigencia,
                'DD-MM-YYYY-HH-mm-ss'
            );
        }
        this.abrirDialogEditarParametro = true;
    }

    criarParametro = () => {
        //this.tipoParametroCriacao = this.tipoParametroSelecionado;
        this.renderConteudoTipo(true);
        this.abrirDialogCriarParametro = true;
    };

    reset() {
        this.dataInicioCriacaoParametro = null;
        this.dataFimCriacaoParametro = null;
        this.horaInicioCriacaoParametro = null;
        this.horaFimCriacaoParametro = null;
        this.valorParametroCriacao = '';
        this.tipoParametroCriacao = '';
        this.chaveParametroCriacao = '';
    }

    handleCloseDialog = () => {
        this.abrirDialogEditarParametro = false;
        this.abrirDialogCriarParametro = false;
        this.abrirDialogExcluirParametro = false;
        this.reset();
    };

    onChangeDateInicio = (data) => {
        if (this.isDataValida(data, this.parametroParaAlteracao.dataFimVigencia)) {
            this.parametroParaAlteracao.dataInicioVigencia = data;
        } else {
            this.parametroParaAlteracao.dataFimVigencia = null;
            this.mensagemStore.abrirMensagemAlerta('Data Fim deve ser POSTERIOR à Data Início.');
        }
    };

    onChangeHoraInicio = (hora) => {
        this.parametroParaAlteracao.horaInicioVigencia = hora;
    };

    onChangeDateFim = (data) => {
        if (this.isDataValida(this.parametroParaAlteracao.dataInicioVigencia, data)) {
            this.parametroParaAlteracao.dataFimVigencia = data;
        } else {
            this.parametroParaAlteracao.dataFimVigencia = null;
            this.mensagemStore.abrirMensagemAlerta('Data Fim deve ser POSTERIOR à Data Início.');
        }
    };

    onChangeHoraFim = (hora) => {
        this.parametroParaAlteracao.horaFimVigencia = hora;
    };

    onChangeDateInicioCriacao = (data) => {
        if (this.isDataValida(data, this.dataFimCriacaoParametro)) {
            this.dataInicioCriacaoParametro = data;
        } else {
            this.dataFimCriacaoParametro = null;
            this.mensagemStore.abrirMensagemAlerta('Data Fim deve ser POSTERIOR à Data Início.');
        }
    };

    onChangeHoraInicioCriacao = (hora) => {
        this.horaInicioCriacaoParametro = hora;
    };

    onChangeDateFimCriacao = (data) => {
        if (this.isDataValida(this.dataInicioCriacaoParametro, data)) {
            this.dataFimCriacaoParametro = data;
        } else {
            this.dataFimCriacaoParametro = null;
            this.mensagemStore.abrirMensagemAlerta('Data Fim deve ser POSTERIOR à Data Início.');
        }
    };

    onChangeHoraFimCriacao = (hora) => {
        this.horaFimCriacaoParametro = hora;
    };

    handleChangeValorParametro = (event) => {
        this.parametroParaAlteracao.valor = event.target.value;
    };

    inputChaveParametroCriacao = (event) => {
        this.chaveParametroCriacao = event.target.value;
    };

    inputValorParametroCriacao = (event) => {
        this.valorParametroCriacao = event.target.value;
    };

    salvar = async () => {
        let parametro = {
            dataInicioVigencia: this.parametroParaAlteracao.dataInicioVigencia
                ? dayjs(this.parametroParaAlteracao.dataInicioVigencia).format('DD-MM-YYYY-HH-mm-ss')
                : null,
            dataFimVigencia: this.parametroParaAlteracao.dataFimVigencia
                ? dayjs(this.parametroParaAlteracao.dataFimVigencia).format('DD-MM-YYYY-HH-mm-ss')
                : null,
            chave: this.parametroParaAlteracao.chave,
            id: this.parametroParaAlteracao.id,
            tipo: this.parametroParaAlteracao.tipo,
            valor: this.parametroParaAlteracao.valor
        };
        try {
            await this.secretariaService.gravarParametro(parametro);
            this.mensagemStore.abrirMensagemSucesso('Parâmetro alterado com sucesso.');
            this.handleCloseDialog();
            await this.parametroStore.inicializar();
            this.renderConteudoTipo();
        } catch (error) {
            this.mensagemStore.abrirMensagemErro(
                `Ocorreu um erro ao tentar alterar o parâmetro: ${ErrorUtil.montarMensagemErro(error)}`
            );
        }
    };

    cadastrarNovoParametro = async () => {
        let tipo = {
            id: this.idTipoParametroCadastro,
            descricao: this.tipoParametroCriacao
        };
        let valor =
            this.idTipoParametroCadastro === ID_TIPO_FEATURE_FLAG ? this.valorFeatureFlag : this.valorParametroCriacao;
        let parametro = {
            dataInicioVigencia: this.dataInicioCriacaoParametro
                ? dayjs(this.dataInicioCriacaoParametro).format('DD-MM-YYYY-HH-mm-ss')
                : null,
            dataFimVigencia: this.dataFimCriacaoParametro
                ? dayjs(this.dataFimCriacaoParametro).format('DD-MM-YYYY-HH-mm-ss')
                : null,
            chave: this.chaveParametroCriacao,
            tipo: tipo,
            valor: valor
        };
        try {
            await this.secretariaService.salvarParametro(parametro);
            this.mensagemStore.abrirMensagemSucesso('Parâmetro criado com sucesso.');
            this.handleCloseDialog();
            runInAction(async () => {
                await this.recarregarParametros();
            });
        } catch (error) {
            this.dataInicioCriacaoParametro = null;
            this.dataFimCriacaoParametro = null;
            this.mensagemStore.abrirMensagemErro(
                `Ocorreu um erro ao tentar criar o parâmetro: ${ErrorUtil.montarMensagemErro(error)}`
            );
        }
    };

    excluirParametro = async (idParametro) => {
        this.idParametroExclusao = idParametro;
        this.abrirDialogExcluirParametro = true;
    };

    handleConfirmaExclusao = async () => {
        try {
            await this.secretariaService.excluirParametro(this.idParametroExclusao);
            this.mensagemStore.abrirMensagemSucesso('Parâmetro excluído com sucesso.');
            this.handleCloseDialog();
            this.parametrosSelecaoCombo = undefined;
            this.idTipoParametro = undefined;
            this.renderConteudoTipo();
            runInAction(async () => {
                await this.recarregarParametros();
            });
        } catch (error) {
            this.mensagemStore.abrirMensagemErro(
                `Ocorreu um erro ao tentar excluir o parâmetro: ${ErrorUtil.montarMensagemErro(error)}`
            );
        }
    };

    handleChangeSwitch = async (parametro) => {
        if (parametro.valor === 'true') {
            parametro.valor = 'false';
        } else {
            parametro.valor = 'true';
        }
        await this.secretariaService.gravarParametro(parametro);
    };

    isDataValida(dataInicio, dataFim) {
        if (dataFim === null) {
            return true;
        } else {
            return dataFim > dataInicio;
        }
    }

    async recarregarParametros() {
        await this.parametroStore.inicializar();
        let parametrosCarregados = this.carregaParametros;
        this.parametrosSelecaoCombo = parametrosCarregados;
        this.renderConteudoTipo();
    }

    isDadosPreenchidosCadastro() {
        if (this.tipoParametroCriacao === this.buscarDescricaoTipoParametro(ID_TIPO_FEATURE_FLAG)) {
            return this.chaveParametroCriacao && this.tipoParametroCriacao !== '';
        } else {
            return (
                this.chaveParametroCriacao !== '' &&
                this.valorParametroCriacao !== '' &&
                this.tipoParametroCriacao !== '' &&
                this.tipoParametroCriacao !== null
            );
        }
    }
    isDadosPreenchidosEditar() {
        if (this.parametroParaAlteracao.tipo === this.buscarDescricaoTipoParametro(ID_TIPO_FEATURE_FLAG)) {
            return this.parametroParaAlteracao.chave && this.parametroParaAlteracao.tipo !== '';
        } else {
            return (
                this.parametroParaAlteracao.chave !== '' &&
                this.parametroParaAlteracao.valor !== '' &&
                this.parametroParaAlteracao.tipo !== ''
            );
        }
    }

    handleChangeValorFeatureFlag = () => {
        this.valorFeatureFlag = !this.valorFeatureFlag;
        this.valorParametroCriacao = JSON.stringify(this.valorFeatureFlag);
    };

    pesquisar = (event) => {
        this.pesquisa = event.target.value;
    };

    limparPesquisa = () => {
        this.pesquisa = '';
    };

    sort() {
        this.ordenacaoDecrescente = !this.ordenacaoDecrescente;
    }

    render() {
        if (!this.verificarAutorizacaoAcesso()) {
            return <TelaUsuarioSemAutorizacaoAcesso />;
        }

        return (
            <>
                <Paper
                    elevation={4}
                    sx={{
                        mt: 2,
                        mr: 2,
                        ml: 2,
                        mb: 2,
                        display: 'flex',
                        height: '96%',
                        width: '100%',
                        flexDirection: 'column',
                        flexShrink: '1'
                    }}
                >
                    <Box>
                        <Typography
                            component="h3"
                            variant="h6"
                            style={{ textAlign: 'center' }}
                        >
                            Parâmetros do Sistema
                        </Typography>
                    </Box>
                    <Box style={{ display: 'flex', height: '100%', flexDirection: 'column' }}>
                        <Box style={{ display: 'flex', width: '900px', flexDirection: 'row' }}>
                            <Box style={{ width: '45%', marginRight: '16px' }}>
                                <AutoComplete
                                    style={{ margin: '8px' }}
                                    label="Tipo de parâmetro"
                                    value={this.tipoParametroSelecionado}
                                    options={this.opcoesTiposParametros}
                                    onChange={this.callbackAutoCompleteTiposParametros}
                                />
                            </Box>
                            <span style={{ width: '50%' }}>
                                {this.isParametrosCarregados() && (
                                    <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'end' }}>
                                        <TextField
                                            id="pesquisa"
                                            name="pesquisa"
                                            label="Pesquisa de parâmetro por chave"
                                            style={stylePesquisa}
                                            value={this.pesquisa}
                                            onChange={this.pesquisar}
                                            maxRows={1}
                                            disabled={this.observableProps.isDisabled}
                                            autoComplete="off"
                                            slotProps={{
                                                htmlInput: { style: { color: this.observableProps.color || 'black' } }
                                            }}
                                        />
                                        <Tooltip
                                            title="Limpar pesquisa"
                                            placement="top"
                                        >
                                            <Clear
                                                style={{ cursor: 'pointer', marginTop: '4px', marginLeft: '8px' }}
                                                onClick={this.limparPesquisa}
                                            />
                                        </Tooltip>
                                    </span>
                                )}
                            </span>
                        </Box>
                        {this.isParametrosCarregados() && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    overflowY: 'scroll',
                                    maxHeight: '65vh',
                                    mt: 2,
                                    ml: 1,
                                    mr: 1
                                }}
                            >
                                <Table
                                    stickyHeader
                                    size="small"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ width: '16px' }}>#</TableCell>
                                            <TableCell style={{ width: '10vh' }}>
                                                Id&nbsp;
                                                {this.ordenacaoDecrescente ? (
                                                    <Tooltip title="Ordenação: Decrescente">
                                                        <span style={{ position: 'absolute', top: '10%' }}>
                                                            <ArrowDownwardIcon
                                                                style={{ cursor: 'pointer', marginLeft: '4px' }}
                                                                onClick={this.sort.bind(this, 'id')}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title="Ordenação: Crescente">
                                                        <span style={{ position: 'absolute', top: '10%' }}>
                                                            <ArrowUpwardIcon
                                                                style={{ cursor: 'pointer', marginLeft: '4px' }}
                                                                onClick={this.sort.bind(this, 'id')}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                )}
                                            </TableCell>
                                            <TableCell style={{ width: '45vh' }}>Chave</TableCell>
                                            <TableCell> Valor </TableCell>
                                            <TableCell style={{ width: '25vh' }}>Data Início Vigência</TableCell>
                                            <TableCell style={{ width: '25vh' }}>Data Fim Vigência</TableCell>
                                            <TableCell style={{ width: '25vh' }}>Tipo</TableCell>
                                            <TableCell style={{ width: '10vh', textAlign: 'center' }}>Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.listaFiltrada.map((parametro, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell
                                                        style={{ width: '16px', fontStyle: 'italic', color: '#bdbdbd' }}
                                                    >
                                                        {index + 1}
                                                    </TableCell>
                                                    <TableCell style={{ width: '10vh' }}> {parametro.id} </TableCell>
                                                    <TableCell style={{ width: '45vh' }}> {parametro.chave} </TableCell>
                                                    <TableCell style={{ maxWidth: '100vh', overflowWrap: 'anywhere' }}>
                                                        {parametro.valor}
                                                    </TableCell>
                                                    <TableCell style={{ width: '25vh' }}>
                                                        {parametro.dataInicioVigencia
                                                            ? dayjs(
                                                                  parametro.dataInicioVigencia,
                                                                  'DD-MM-YYYY-hh-mm-ss'
                                                              ).format('DD/MM/YYYY')
                                                            : '-'}
                                                    </TableCell>
                                                    <TableCell style={{ width: '25vh' }}>
                                                        {parametro.dataFimVigencia
                                                            ? dayjs(
                                                                  parametro.dataFimVigencia,
                                                                  'DD-MM-YYYY-hh-mm-ss'
                                                              ).format('DD/MM/YYYY')
                                                            : '-'}
                                                    </TableCell>
                                                    <TableCell style={{ width: '25vh' }}>
                                                        {parametro.tipo.descricao}
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            width: '10vh',
                                                            display: 'tableCell',
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        <span style={{ display: 'flex', justifyContent: 'center' }}>
                                                            <Tooltip title={<Typography>Editar</Typography>}>
                                                                <EditIcon
                                                                    color="primary"
                                                                    sx={{
                                                                        alignSelf: 'center',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    onClick={this.editarParametro.bind(this, parametro)}
                                                                />
                                                            </Tooltip>
                                                            {this.idTipoParametro === ID_TIPO_GERAL && (
                                                                <Tooltip title={<Typography>Excluir</Typography>}>
                                                                    <DeleteIcon
                                                                        color="secondary"
                                                                        sx={{
                                                                            alignSelf: 'center',
                                                                            ml: 1,
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        onClick={this.excluirParametro.bind(
                                                                            this,
                                                                            parametro.id
                                                                        )}
                                                                    />
                                                                </Tooltip>
                                                            )}
                                                            {this.idTipoParametro === ID_TIPO_FEATURE_FLAG && (
                                                                <span style={{ display: 'flex' }}>
                                                                    <Tooltip title={<Typography>Excluir</Typography>}>
                                                                        <DeleteIcon
                                                                            color="secondary"
                                                                            sx={{
                                                                                alignSelf: 'center',
                                                                                ml: 1,
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            onClick={this.excluirParametro.bind(
                                                                                this,
                                                                                parametro.id
                                                                            )}
                                                                        />
                                                                    </Tooltip>
                                                                    <Switch
                                                                        sx={{
                                                                            alignSelf: 'center',
                                                                            cursor: 'pointer'
                                                                        }}
                                                                        checked={JSON.parse(parametro.valor)}
                                                                        onChange={this.handleChangeSwitch.bind(
                                                                            this,
                                                                            parametro
                                                                        )}
                                                                    />
                                                                </span>
                                                            )}
                                                        </span>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </Box>
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', mt: 1, ml: 0, mr: 2, mb: 2, alignSelf: 'end' }}>
                        <Button
                            onClick={this.criarParametro}
                            color="primary"
                            variant="contained"
                            endIcon={<AddCircleIcon />}
                        >
                            Adicionar parâmetro
                        </Button>
                    </Box>
                </Paper>
                {this.abrirDialogEditarParametro && (
                    <Dialog
                        onClose={this.handleCloseDialog}
                        open={this.abrirDialogEditarParametro}
                        maxWidth={false}
                    >
                        <DialogTitle
                            id="dialog-edicao-parametro"
                            style={{ paddingBottom: '0px' }}
                        >
                            {`Edição do parâmetro "${this.parametroParaAlteracao.chave}"`}
                        </DialogTitle>
                        <Box style={{ display: 'flex', flexDirection: 'column', margin: '4px', width: '80vh' }}>
                            <TextField
                                label="Valor"
                                multiline
                                maxRows={5}
                                value={this.parametroParaAlteracao.valor}
                                onInput={this.handleChangeValorParametro}
                                style={{ marginLeft: '8px', marginBottom: '8px' }}
                                disabled={this.idTipoParametro === ID_TIPO_FEATURE_FLAG}
                            />
                            <Box style={{ marginLeft: '8px', marginBottom: '8px' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        sx={{ width: 260 }}
                                        label="Data Início Vigência"
                                        value={this.parametroParaAlteracao.dataInicioVigencia}
                                        format="DD/MM/YYYY HH:mm:ss"
                                        onChange={this.onChangeDateInicio}
                                        slotProps={{
                                            field: { clearable: true }
                                        }}
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </Box>
                            <Box style={{ marginLeft: '8px', marginBottom: '8px' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        sx={{ width: 260 }}
                                        label="Data Fim Vigência"
                                        value={this.parametroParaAlteracao.dataFimVigencia}
                                        format="DD/MM/YYYY HH:mm:ss"
                                        onChange={this.onChangeDateFim}
                                        slotProps={{
                                            field: { clearable: true }
                                        }}
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </Box>
                            <DialogActions>
                                <Box>
                                    <Button
                                        onClick={this.handleCloseDialog}
                                        color="secondary"
                                        variant="outlined"
                                        endIcon={<CancelIcon />}
                                    >
                                        Cancelar
                                    </Button>
                                    <Tooltip
                                        placement="top"
                                        title={
                                            <Typography className="tooltipBotao">
                                                {!this.isDadosPreenchidosEditar()
                                                    ? 'Valor do parâmetro é obrigatório'
                                                    : 'Gravar'}
                                            </Typography>
                                        }
                                    >
                                        <span>
                                            <Button
                                                disabled={!this.isDadosPreenchidosEditar()}
                                                onClick={this.salvar}
                                                color="primary"
                                                variant="contained"
                                                endIcon={<SaveIcon />}
                                                sx={{ ml: 2 }}
                                            >
                                                Salvar
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </Box>
                            </DialogActions>
                        </Box>
                    </Dialog>
                )}
                {this.abrirDialogCriarParametro && (
                    <Dialog
                        onClose={this.handleCloseDialog}
                        open={this.abrirDialogCriarParametro}
                        maxWidth={false}
                    >
                        <DialogTitle
                            id="dialog-cadastro-parametro"
                            style={{ paddingBottom: '0px' }}
                        >
                            Cadastro de Novo Parâmetro
                        </DialogTitle>
                        <Box style={{ display: 'flex', flexDirection: 'column', margin: '4px', width: '80vh' }}>
                            <TextField
                                label="Chave"
                                style={{ marginLeft: '8px', marginBottom: '4px' }}
                                value={this.chaveParametroCriacao}
                                onInput={this.inputChaveParametroCriacao}
                            />
                            {this.tipoParametroCriacao === this.buscarDescricaoTipoParametro(ID_TIPO_FEATURE_FLAG) ? (
                                <Box style={{ display: 'flex', flexDirection: 'row', marginTop: '4px' }}>
                                    <TextField
                                        label="Valor"
                                        maxRows={1}
                                        style={{ marginLeft: '8px', marginBottom: '8px' }}
                                        value={this.valorFeatureFlag}
                                        disabled
                                    />
                                    <Box style={{ marginTop: '8px' }}>
                                        <Switch
                                            style={{ alignSelf: 'center', cursor: 'pointer' }}
                                            checked={this.valorFeatureFlag}
                                            onChange={this.handleChangeValorFeatureFlag}
                                        />
                                    </Box>
                                </Box>
                            ) : (
                                <TextField
                                    label="Valor"
                                    multiline
                                    maxRows={5}
                                    style={{ marginLeft: '8px', marginBottom: '8px' }}
                                    value={this.valorParametroCriacao}
                                    onInput={this.inputValorParametroCriacao}
                                />
                            )}
                            <Box style={{ marginLeft: '8px', marginBottom: '8px' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        sx={{ width: 260 }}
                                        label="Data Início Vigência"
                                        ampm={false}
                                        format="DD/MM/YYYY HH:mm:ss"
                                        value={this.dataInicioCriacaoParametro}
                                        onChange={this.onChangeDateInicioCriacao}
                                        slotProps={{
                                            field: { clearable: true }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Box>
                            <Box style={{ marginLeft: '8px', marginBottom: '8px' }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                        sx={{ width: 260 }}
                                        label="Data Fim Vigência"
                                        ampm={false}
                                        format="DD/MM/YYYY HH:mm:ss"
                                        value={this.dataFimCriacaoParametro}
                                        onChange={this.onChangeDateFimCriacao}
                                        slotProps={{
                                            field: { clearable: true }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Box>
                            <Box style={{ margin: '8px', marginTop: '16px' }}>
                                <AutoComplete
                                    placement="bottom-start"
                                    label="Tipo de parâmetro"
                                    value={this.tipoParametroCriacao}
                                    options={this.opcoesTiposParametros}
                                    onChange={this.callbackAutoCompleteTipoParametroCriado}
                                    desabilitarLimpar={false}
                                />
                            </Box>
                            <DialogActions>
                                <Box>
                                    <Button
                                        onClick={this.handleCloseDialog}
                                        color="secondary"
                                        variant="outlined"
                                        endIcon={<CancelIcon />}
                                    >
                                        Cancelar
                                    </Button>
                                    <Tooltip
                                        placement="top"
                                        title={
                                            <Typography className="tooltipBotao">
                                                {!this.isDadosPreenchidosCadastro()
                                                    ? 'Favor preencher Chave, Valor e Tipo de parâmetro'
                                                    : 'Gravar'}
                                            </Typography>
                                        }
                                    >
                                        <span>
                                            <Button
                                                disabled={!this.isDadosPreenchidosCadastro()}
                                                onClick={this.cadastrarNovoParametro}
                                                color="primary"
                                                variant="contained"
                                                endIcon={<SaveIcon />}
                                                sx={{ ml: 2 }}
                                            >
                                                Salvar
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </Box>
                            </DialogActions>
                        </Box>
                    </Dialog>
                )}
                <ModalConfirmacao
                    open={this.abrirDialogExcluirParametro}
                    titulo={'Exclusão de parâmetro'}
                    tipoConfirmacao={TIPO_CONFIRMACAO.EXCLUSAO}
                    callbackCancelar={this.handleCloseDialog}
                    callbackConfirmar={this.handleConfirmaExclusao}
                >
                    <Typography display={'inline'}>Confirma a exclusão do parâmetro </Typography>
                    <Typography
                        display={'inline'}
                        fontWeight={'bold'}
                        noWrap
                    >
                        {this.idParametroExclusao}
                    </Typography>
                    <Typography display={'inline'}>?</Typography>
                </ModalConfirmacao>
            </>
        );
    }

    isParametrosCarregados() {
        return this.parametrosSelecaoCombo && this.parametrosSelecaoCombo.length > 0;
    }
}

export default inject('stores')(observer(ParametrosSistema));
